const AuthReducer = (state, action) => {
  switch (action.type) {
    case "LOGIN": {
      return {
        currentUser: action.payload || null, // Ensures valid user data
      };
    }
    case "LOGOUT": {
      return {
        currentUser: null,
      };
    }
    default:
      console.warn(`Unhandled action type: ${action.type}`); // Debugging log
      return state;
  }
};

export default AuthReducer;
